import getLinkText from "../../../helpers/getLinkText";
import { trackEvent } from "../../../trackEvent";
import externalLink from "./externalLink";

/**
 * Push any footer links to datalayer when they are in the footer tag
 * Basic DOM markup assumed.
 * 
 * <footer>
 *  <div data-gtm-subsection="social">
 *   <a href="">Facebook</a>
 *  </div>
 * </footer>
 */

const test = ({ target }) => target.closest("footer");

const push = ({ link, target, isInternal }) => {
  trackEvent({
    event: "click_footer",
    event_type: "click",
    element_url: link,
    element_text: getLinkText({ link, target })
  });

  // Also push to external if it is an external link
  const isExternal = externalLink.test({ link, isInternal });
  if (isExternal) externalLink.push({ link, target });
}

export default {
  name: "footer",
  test,
  push
};